import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  advancedSearchParameters: {},
  filterButton: false,
  pathname: "",
};

const advancedSearchSlice = createSlice({
  name: "advancedSearch",
  initialState,
  reducers: {
    salvarEstado(state, action) {
      state.advancedSearchParameters = { ...action.payload };
    },
    estadoBotao(state, action) {
      state.filterButton = action.payload;
    },
    estadoPathname(state, action) {
      state.pathname = action.payload;
    },
    reset: () => initialState,
  },
});

export const advancedSearchActions = advancedSearchSlice.actions;

export default advancedSearchSlice.reducer;
